import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modalContainer"]

  open(event) {
    event.preventDefault()
    this.modalContainerTarget.classList.remove("hidden")
    // Dispatch event so other controllers can enhance modal content
    this.element.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }))
  }

  close(event) {
    event.preventDefault()
    this.modalContainerTarget.classList.add("hidden")
  }
}